import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { mask } from 'remask';

import { CREDIT_CARD } from '../../../../consts/patterns';

import { CarBrand } from '../CardBrand';

export function CardInput({
  control,
  name,
  controllerProps = {},
  isDisplay = false,
  cardBrand = null,
  ...rest
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <TextField
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: (
              <CarBrand cardNumber={field?.value} defaultBrand={cardBrand} />
            ),
          }}
          {...field}
          {...rest}
          value={
            isDisplay ? field.value : mask(field?.value ?? '', CREDIT_CARD)
          }
        />
      )}
      {...controllerProps}
    />
  );
}

export default CardInput;
